import { combineReducers } from 'redux'

import alert from './alert'

export const reducer = combineReducers({
  alert: alert.reducer,
})

export default reducer
